import React from 'react';

export const DefaultProvider = ({ children }) => <>{children}</>;

export default DefaultProvider;
